import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable  } from 'rxjs';
import { map } from 'rxjs/operators'
import { EnvService } from '../../core/env.service';
import { GlobalService } from '../../commonservices/global.service';

const headers = new HttpHeaders().set('Content-Type','application/json')

@Injectable()
export class CountriesService {
    progress: number =0;
    constructor(
        private _httpClient: HttpClient, 
        public _env: EnvService,
        private globalS: GlobalService) {
    }


}